import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BridgeService {
  private BASE_URL = environment.BASE_URL;

  constructor(private http: HttpClient) { }

  /**
   * Get Transactions
   * @param {object} query
   * @return {object}
   */
  getTransactions(query) {
    let request_url = (!query.operation)
      ? `${this.BASE_URL}/v1/transactions/address?address=${query.account}&current_page=${query.current_page}&records_per_page=${query.records_per_page}`
      : `${this.BASE_URL}/v1/transactions/address?address=${query.account}&operation=${query.operation}&current_page=${query.current_page}&records_per_page=${query.records_per_page}`;
    return this.http.get(request_url);
  }

  getSignature(query) {
    return this.http.post(`${this.BASE_URL}/v1/signature`, query);
  }

  // swapEthToBsc(query) {
  //   return this.http.post(`${this.BASE_URL}/v1/mint-binance`, query);
  // }

  // swapBscToEth(query) {
  //   return this.http.post(`${this.BASE_URL}/v1/mint-rinkeby`, query);
  // }

  deleteTx(params) {
    return this.http.post(`${this.BASE_URL}/v1/delete-transaction`, params);
  }

}
